<template>
  <div class="fixed-con" id="fix">
    <!-- 右则固定区域 start -->
    <div class="right-side-bar theme-color_bg">
      <div class="side-con">
        <div class="single">
          <img :src="`${imgPath}/oneold/layout/right_01.png`" alt="" class="img0" />
          <p class="text">咨询热线</p>
          <div class="hover-con">
            <img :src="`${imgPath}/oneold/layout/log_phone.png`" alt="" class="img" />
            <div class="hover-text">
              <p>咨询热线</p>
              <p>{{ pageType == "hot" ? SERVICE_PHONE_HOT : SERVICE_PHONE }}</p>
            </div>
          </div>
        </div>
        <div v-if="username" class="single">
          <img :src="`${imgPath}/oneold/layout/right_03.png`" alt="" class="img1" />
          <p class="text">售后服务</p>
          <div class="hover-con hover-con1">
            <img :src="`${imgPath}/oneold/layout/login-code.jpg`" alt="" class="img mb--10" />
            <p>微信扫码一对一服务</p>
          </div>
        </div>
        <div v-else class="single" @click="jumpHandle">
          <img :src="`${imgPath}/oneold/layout/right_02.png`" alt="" class="img1" />
          <p class="text">咨询热线</p>
        </div>
      </div>
    </div>
    <!-- 右则固定区域 start -->

    <!-- 底部固定区域 start -->
    <BottomBanner v-if="footerBannerShow" @register="showRegister" />
    <div v-if="footerBannerShow" class="seize-seat width-100"></div>
    <!-- 底部固定区域 end -->
  </div>
</template>
<script>
import {imgPath, SERVICE_PHONE_HOT,SERVICE_PHONE,PHONE_WEBCHAT_URL} from "@/utils/constants/constants";
import BottomBanner from "./model/BottomBanner.vue"

export default {
  name: "FixedSuspension",
  components: {BottomBanner},
  data() {
    return {
      username: '',
      pageType:'',
      SERVICE_PHONE_HOT,
      SERVICE_PHONE,
      imgPath,
      footerBannerShow:true
    };
  },
  computed: {


  },
  created() {

  },
  mounted() {

  },
  methods: {
    jumpHandle() {
      window.open(PHONE_WEBCHAT_URL)
    },
    showRegister(){
     this.$emit('register')
    }
  }
};
</script>


<style lang="scss" >
@import "@/assets/variable.scss";
.right-side-bar {
  position: fixed;
  right: 0;
  top: 138px;
  border: 1px solid rgba(229, 229, 229, 1);
  box-shadow: 0px 0px 10px 0px;
  border-radius: 10px 0px 0px 10px;
  margin-bottom: 31px;
  margin-left: auto;
  margin-right: 0;
  width: 81px;
  text-align: center;
  color: #fff;
  font-weight: 500;
  padding: 13px 0;
  .single {
    border-bottom: 1px solid #fff;
    width: 100%;
    margin: 14px 0%;
    position: relative;
    cursor: pointer;
    .img {
      margin: 0 auto;
    }
    .img0 {
      width: 50px;
    }
    .img1 {
      width: 30px;
    }
    .text {
      margin-top: 10px;
      margin-bottom: 20px;
      display: inline-block;
      padding: 2px 4px;
      border-radius: 6px;
    }
  }

  .side-con {
    .single {
      &:hover .hover-con {
        display: flex;
      }
      &:last-child {
        border: none;
      }
    }
  }

  .hover-con {
    display: none;
    box-sizing: border-box;
    position: absolute;
    width: 140px;
    right: 90px;
    top: 0px;
    padding: 10px 14px;
    background: #ffffff;
    border: 1px solid #fff;
    border-radius: 10px;
    color: #333;
    text-align: left;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
    .img {
      width: 12px;
      height: 12px;
    }
    .hover-text {
      p {
        &:last-child {
          margin-top: 6px;
          color: $theme-color;
        }
      }
    }
    &:before {
      content: "";
      width: 0px;
      height: 0px;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 6px solid #fff;
      position: absolute;
      top: 50%;
      right: -6px;
      transform: translateY(-50%);
    }
  }
  .hover-con1 {
    flex-direction: column;
    .img {
      width: 100px;
      height: 100px;
    }
  }
}

.footer-fixed {
  min-width: 1000px;
  //background: url("@/assets/images/layout/footer_bg.png") center;
  background-size: 100% 40px !important;
  position: fixed;
  left: 0;
  bottom: 0;
  height: 40px;
}
.footer-fixed-hot {
  //background: url("@/assets/images/layout/footer_bg_hot.png") center;
}
.imgs-block {
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  right: 30px;
  width: 260px;
  align-items: center;
  .img {
    cursor: pointer;
  }
  .footer-receive-btn {
    height: 30px;
  }
  .footer-colse {
    height: 20px;
  }
}

.seize-seat {
  height: 50px;
}
</style>
